import React, { useEffect, useState } from "react";
import { Box, Grid, Typography } from "@mui/material";

import style from "./index.module.css";

import AppleIcon from "@/assets/appStore.png";
import AppStoreIcon from "@/assets/playstore.png";
import CheckIcon from "@/assets/checkIcon.png";

import GetImages from "@/components/GetImages";
import Breadcrumb from "@/components/Breadcrumb";

import { getConfigurationApi } from "@/utils/apis/config";

import { IConfigKey } from "@/models";

const OurAppFeature: React.FC = () => {
  const [appFeatureData, setAppFeatureData] = useState<any>(null);

  useEffect(() => {
    const fetchAppFeatureData = async () => {
      try {
        const data = await getConfigurationApi(IConfigKey.OUR_APP_FEATURE);
        if ("result" in data) {
          setAppFeatureData(data.result);
        }
      } catch (error) {
        console.error("Error fetching app feature data:", error);
      }
    };
    fetchAppFeatureData();
  }, []);

  return (
    <Grid item xs={12}>
      <Grid className={style.breadCrumb}>
        <Breadcrumb
          items={[
            { label: "Home", link: "/home" },
            { label: "App Features", link: "", isCurrent: true },
          ]}
        />
      </Grid>
      <Grid className={style.inverseContainer}>
        {appFeatureData && appFeatureData?.section1[1]?.coverUrl ? (
          <img
            src={appFeatureData.section1[1].coverUrl}
            height="500px"
            alt=""
          />
        ) : (
          <GetImages name="appFeature1" width="400px" height="430px" />
        )}
        <Grid>
          <Typography className={style.headingText}>
            {appFeatureData?.section1[0]?.headingText ||
              "Better Care for Your Brain & Spine"}
          </Typography>
          <Grid className={style.textBoxPoint}>
            {appFeatureData?.section1.slice(2).map((item, index) => (
              <Grid
                key={index}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "1.2rem",
                }}
              >
                <Box
                  component="img"
                  src={item.iconUrl}
                  width={18}
                  height={18}
                  alt=""
                  onError={(e: any) => (e.currentTarget.src = CheckIcon)}
                />
                <Typography className={style.section1PointText} key={index}>
                  {item.textPoint}
                </Typography>
              </Grid>
            ))}
          </Grid>
          <div className={style.buttonContainer}>
            <div className={style.buttonBox}>
              <img src={AppStoreIcon} alt="app" />
              <div className={style.buttonText}>
                <p>GET IT ON</p>
                <h6>Google Play</h6>
              </div>
            </div>
            <div className={style.buttonBox}>
              <img src={AppleIcon} alt="app" />
              <div className={style.buttonText}>
                <p>Download on the</p>
                <h6>App Store</h6>
              </div>
            </div>
          </div>
        </Grid>
      </Grid>
      <Grid item>
        {appFeatureData &&
          Object.keys(appFeatureData)
            .slice(1)
            .map((data, index) => (
              <div
                className={
                  index % 2 === 0
                    ? style.flexContainers
                    : style.inverseContainer
                }
              >
                <div className={style.imageBox}>
                  <img src={appFeatureData[data].imageUrl} alt="" />
                </div>
                <div className={style.textBox}>
                  <Typography className={style.headingText}>
                    {appFeatureData[data].headingText}
                  </Typography>
                  <Typography className={style.pointText}>
                    {appFeatureData[data].description}
                  </Typography>
                </div>
              </div>
            ))}
      </Grid>
    </Grid>
  );
};

export default OurAppFeature;
